<div class="container" id="containerRefID">
  <!-- <div id="zoom-controls" [ngClass]="[
      leftState === 'open' ? 'home-control' : 'home-close',
      hideHeader ? 'zoom-control1' : 'null'
    ]" *ngIf="
      showLegend &&
      tools.home &&
      HideForEmbed !== 'true'
    ">


  </div> -->
  <div id="zoom-controls" [ngClass]="[
      leftState === 'open' ? 'zoom-control' : 'zoom-close',
      hideHeader ? 'zoom-control1' : 'null'
    ]" *ngIf="
      showLegend &&
      mapService.elementsVisibility['zoom_in_out'] &&
      HideForEmbed !== 'true'
    ">
    <a class="closerToolTip4" style="text-decoration: none;" *ngIf="tools.home">
      <img (click)="defualtExtent()" style="padding: 0px 2px 0px 2px;width: 22px;" alt="home" src="../../../../../assets//img/home.svg"/>
      <span class="tooltiptext4" style="text-decoration: none;" id="homeToolltip" [innerHtml]="
            mapService.templatetoolTips['home']
          "></span>
    </a>
    <a (click)="sacleLine.zoomIn()">+</a>
    <a (click)="sacleLine.zoomOut()">-</a>

  </div>
  <div class="row">
    <!-- watermark -->
    <img *ngIf="mapService.elementsVisibility['watermark']" id="watermark"
      src=" https://app.mapport.com/static/img/watermark_v3.png" class="center-block" />
    <div id="map" class="map" [ngClass]="[
        HideForEmbed === 'true' ? 'map1' : 'map',
        hideHeader === true ? 'map_goTop' : 'null',
        geoLockTool ? 'map-goTop-for-embed' : 'null'
      ]" >
      <div *ngIf="
          showLegend &&
          mapService.elementsVisibility['zoom_level_scale'] &&
          HideForEmbed !== 'true'
        " [ngClass]="leftState === 'open' ? 'map-controls' : 'close-map-controls'">
        <div id="wind-info" class="wind-info"><span></span></div>
        <div id="scale-control">
          <div class="olControlScaleLineTop" [ngStyle]="{ width: sacleLine.kmPx }"
            style="visibility: visible; font-weight: initial">
            {{ sacleLine.km }}
          </div>
          <div class="olControlScaleLineBottom" [ngStyle]="{ width: sacleLine.ftPx }"
            style="visibility: visible; font-weight: initial">
            {{ sacleLine.ft }}
          </div>
        </div>
        <div id="zoom-level">
          <p style="font-weight: initial">Zoom Level</p>
          <span style="font-weight: initial">{{ newZoom || currZoom }}</span>
        </div>
      </div>
      <div>
        <div style="
            margin-left: 5px;
            margin-right: 5px;
            z-index: 1000000;
            position: absolute;
            left: 0px;
            bottom: 0px;
          ">
          <a target="_blank" rel="noopener" title="Open this area in Google Maps (opens a new window)" style="
              position: static;
              overflow: visible;
              float: none;
              display: inline;
            ">
            <div style="width: 66px; height: 26px; cursor: pointer">
              <img alt="" src="https://maps.gstatic.com/mapfiles/api-3/images/google_white5.png" draggable="false"
                style="
                  position: absolute;
                  left: 0px;
                  top: 0px;
                  width: 66px;
                  height: 26px;
                  user-select: none;
                  border: 0px;
                  padding: 0px;
                  margin: 0px;
                " />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
